<script setup lang="ts">
// One group of a page, like a SwiftUI `Section` / a grouped table view section: an optional header, the content (a search
// field, a `UiList`, buttons, ...) and an optional footer, followed by the gap to the next group. The gap is the group's
// own bottom margin (`--ui-group-gap`), so pages never space their blocks by hand; the space left after the last group is fine.
defineProps<{ title?: string; footer?: string }>()
</script>

<template>
  <section class="ui-group" data-ui-group>
    <h3 v-if="title" class="title">{{ title }}</h3>
    <slot />
    <div v-if="footer || $slots.footer" class="footer ui-hint">
      <slot name="footer">{{ footer }}</slot>
    </div>
  </section>
</template>

<style scoped>
.ui-group {
  margin: 0 0 var(--ui-group-gap);
  min-width: 0;
}

.title {
  margin: 0 0.25rem 0.4rem;
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--tg-section-header-text-color);
}

.footer {
  margin: 0.4rem 0.25rem 0;
}

.footer:empty {
  display: none;
}

.footer :slotted(p) {
  margin: 0 0 0.25rem;
}
</style>
